import { buildQueryParams } from '../../../common/misc';
import { requestBuilder } from '../../../http/RequestBuilder';
import type { CardWidgetUrlRequest } from '../../types/Card';

const useGetCardWidgetUrl = requestBuilder.query<
    { url: string },
    CardWidgetUrlRequest
>({
    endpoint: (query: CardWidgetUrlRequest) =>
        `/api/card/card-widget-url${buildQueryParams(query)}`,
    queryKey: (query: CardWidgetUrlRequest) =>
        `getCardWidgetUrl/${buildQueryParams(query)}`,
});

export default useGetCardWidgetUrl;
